<div>&nbsp;</div>
<div>
  <p-selectButton
    [options]="switchFilterStates"
    (onChange)="onFilter()"
    [(ngModel)]="switchFilterState"
  ></p-selectButton>
</div>
<div class="list-container">
  <p-table
    #dt
    [value]="cvDatabaseAccessTokenRequestList"
    showGridlines
    [rowHover]="true"
    [lazy]="true"
    [paginator]="true"
    [rows]="pageSize"
    (onLazyLoad)="onLoad($event)"
    [totalRecords]="totalRecords"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>
          <input
            pInputText
            type="text"
            placeholder="{{ 'label.Customer' | translate }}"
            (input)="dt.filter($event.target.value, 'fullName', 'contains')"
          />
        </th>
        <th>
          {{ 'label.Portfolio' | translate }}
        </th>
        <th>
          {{ 'label.AccountManager' | translate }}
        </th>
        <th style="width: 268px">
          {{ 'label.Product' | translate }}
        </th>
        <th style="width: 60px">
          {{ 'label.Views' | translate }}
        </th>

        <th [pSortableColumn]="'createDate'" style="width: 100px">
          {{ 'label.PurchaseDate' | translate }}
          <p-sortIcon
            [field]="'createDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'processDate'" style="width: 100px">
          {{ 'label.ActivateDate' | translate }}
          <p-sortIcon
            [field]="'processDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th [pSortableColumn]="'fullAccessExpireDate'" style="width: 100px">
          {{ 'label.ExpireDate' | translate }}
          <p-sortIcon
            [field]="'fullAccessExpireDate'"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>

        <th>
          {{ 'label.Action' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-request
      let-expanded="expanded"
      let-columns="columns"
    >
      <tr>
        <td>
          <span class="customer-view-link"
            ><a [routerLink]="['/customers/view', request.requestCustomerId]">{{
              request?.customer?.name
            }}</a></span
          >
        </td>

        <td>
          <span class="customer-view-link"
            ><a [routerLink]="['/portfolios/view', request.portfolioId]">{{
              request?.portfolioName
            }}</a></span
          >
        </td>
        <td>
          <span>{{ request?.portfolioAccountManagerName }}</span>
        </td>
        <td>
          <span
            class="product-view"
            *ngIf="
              request.status != CvDatabaseAccessTokenRequestStatus.Pending ||
              request?.issuedTokens[0]?.storeItem?.product?.type ==
                ProductType.EventCvDatabaseAccess
            "
          >
            {{ request?.issuedTokens[0]?.storeItem?.product?.name }}
          </span>
          <span
            *ngIf="
              request.status == CvDatabaseAccessTokenRequestStatus.Pending &&
              request?.issuedTokens[0]?.storeItem?.product?.type !=
                ProductType.EventCvDatabaseAccess
            "
          >
            <select [(ngModel)]="request.issuedTokens[0].storeItemId">
              <option *ngFor="let item of storeItems" value="{{ item.itemId }}">
                {{ item.product.name }}
              </option>
            </select>
          </span>
        </td>
        <td>
          <span>{{ request?.issuedTokens[0]?.viewCount }}</span>
        </td>
        <td>
          <span>{{ request.createDate | date : dateFormat }}</span>
        </td>
        <td>
          <span
            *ngIf="
              switchFilterState == switchFilterStatEnum.Active ||
              switchFilterState == switchFilterStatEnum.Terminated
            "
            >{{ request.processDate | date : dateFormat }}</span
          >
        </td>
        <td>
          <span>{{
            request?.issuedTokens[0]?.fullAccessExpireDate | date : dateFormat
          }}</span>
        </td>
        <td>
          <div class="request-action-link">
            <a
              *ngIf="
                request.status === CvDatabaseAccessTokenRequestStatus.Pending &&
                hasRequestApproveRejectPermission
              "
              (click)="onApproveRequestClick(request)"
              >{{ 'label.Approve' | translate }}
            </a>
            <a
              *ngIf="
                request.status === CvDatabaseAccessTokenRequestStatus.Pending &&
                hasRequestApproveRejectPermission
              "
              (click)="onRejectRequestClick(request)"
              >{{ 'label.Reject' | translate }}
            </a>
            <hr-confirm-with-checkbox
              *ngIf="
                request.status ===
                  CvDatabaseAccessTokenRequestStatus.Approved &&
                hasRequestTerminationPermission
              "
              [actionName]="'label.Cancel' | translate"
              [checkboxLabel]="'label.AffectBilling' | translate"
              [content]="'label.AreYouSure' | translate"
              [targetId]="request.cvDatabaseAccessTokenRequestId"
              [header]="'label.Cancel' | translate"
              (onResult)="onRevokeRequestClick($event)"
            ></hr-confirm-with-checkbox>
          </div>
        </td>
      </tr>
    </ng-template>
    <!-- <p-column field="fullName" filterPlaceholder="{{'label.Customer' | translate}}" [filter]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="customer-view-link"><a [routerLink]="['/customers/view', request.requestCustomerId]">{{request?.customer?.name}}</a></span>
            </ng-template>
        </p-column>
        <p-column field="portfolioName" header="{{'label.Portfolio' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="customer-view-link"><a [routerLink]="['/portfolios/view', request.portfolioId]">{{request?.portfolioName}}</a></span>
            </ng-template>
        </p-column>
        <p-column field="portfolioAccountManagerName" header="{{'label.AccountManager' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span >{{request?.portfolioAccountManagerName}}</span>
            </ng-template>
        </p-column>
        <p-column header="{{'label.Product' | translate}}" [style]="{'width': '268px'}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span class="product-view" *ngIf="request.status != CvDatabaseAccessTokenRequestStatus.Pending || request?.issuedTokens[0]?.storeItem?.product?.type == ProductType.EventCvDatabaseAccess">
                    {{request?.issuedTokens[0]?.storeItem?.product?.name}}
                </span>
                <span *ngIf="request.status == CvDatabaseAccessTokenRequestStatus.Pending && request?.issuedTokens[0]?.storeItem?.product?.type != ProductType.EventCvDatabaseAccess">
                    <select [(ngModel)]="request.issuedTokens[0].storeItemId">
                        <option *ngFor="let item of storeItems" value="{{item.itemId}}">{{item.product.name}}</option>
                    </select>
                </span>
            </ng-template>
        </p-column>
        <p-column header="{{'label.Views' | translate}}" [style]="{'width': '60px'}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span>{{request?.issuedTokens[0]?.viewCount}}</span>
            </ng-template>
        </p-column>
        <p-column field="createDate" header="{{'label.PurchaseDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span>{{request[col.field] | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column field="processDate" header="{{'label.ActivateDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span *ngIf="switchFilterState == switchFilterStatEnum.Active || switchFilterState == switchFilterStatEnum.Terminated">{{request[col.field] | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column field="fullAccessExpireDate" header="{{'label.ExpireDate' | translate}}" [sortable]="true">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <span>{{request?.issuedTokens[0]?.fullAccessExpireDate | date:dateFormat}}</span>
            </ng-template>
        </p-column>
        <p-column header="{{'label.Action' | translate}}">
            <ng-template let-col let-request="rowData" pTemplate="body">
                <div class="request-action-link">
                    <a *ngIf="request.status === CvDatabaseAccessTokenRequestStatus.Pending && hasRequestApproveRejectPermission" (click)="onApproveRequestClick(request)">{{'label.Approve' | translate}} </a>
                    <a *ngIf="request.status === CvDatabaseAccessTokenRequestStatus.Pending && hasRequestApproveRejectPermission" (click)="onRejectRequestClick(request)">{{'label.Reject' | translate}} </a>
                    <hr-confirm-with-checkbox *ngIf="request.status === CvDatabaseAccessTokenRequestStatus.Approved && hasRequestTerminationPermission" [actionName]="label.'Cancel' | translate"
                        [checkboxLabel]="'label.AffectBilling' | translate" [content]="'label.AreYouSure' | translate"
                        [targetId]=request.cvDatabaseAccessTokenRequestId [header]="'label.Cancel' | translate" (onResult)="onRevokeRequestClick($event)"></hr-confirm-with-checkbox>
                </div>
            </ng-template>
        </p-column> -->
  </p-table>
</div>
